import { cn } from '@exam-room/utils';

import type { SnackbarMessage } from '../../providers/snackbar/types';

import { SnackbarItem } from './SnackbarItem';

interface SnackbarContainerProps {
  /**
   * List of snack-bars to display
   */
  snackbars: SnackbarMessage[];
  onClose: (id: string) => void;
  position:
    | 'top-center'
    | 'top-right'
    | 'top-left'
    | 'bottom-center'
    | 'bottom-right'
    | 'bottom-left';
}

const positionStyles = {
  'top-center': 'top-4 left-1/2 -translate-x-1/2',
  'top-right': 'top-4 right-4',
  'top-left': 'top-4 left-4',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2',
  'bottom-right': 'bottom-4 right-4',
  'bottom-left': 'bottom-4 left-4',
};

export function SnackbarContainer({ snackbars, onClose, position }: SnackbarContainerProps) {
  if (snackbars.length === 0) return null;

  return (
    <div className={cn('pointer-events-none fixed z-50 flex flex-col', positionStyles[position])}>
      {snackbars.map((snackbar) => (
        <SnackbarItem key={snackbar.id} snackbar={snackbar} onClose={onClose} />
      ))}
    </div>
  );
}
